export const FISHING_YEAR = {
  ONE_YEAR_BEFORE: 1,
  TWO_YEAR_BEFORE: 2,
};
